// <shipping-estimate> — see snippets/shipping-estimate.liquid for the data model.
if (!customElements.get('shipping-estimate')) {
  customElements.define(
    'shipping-estimate',
    class ShippingEstimate extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        const read = (selector) => {
          try {
            return JSON.parse(this.querySelector(selector).textContent);
          } catch (e) {
            return null;
          }
        };
        const data = read('[data-ship-zones]');
        this.strings = read('[data-ship-strings]');
        if (!data || !this.strings) {
          this.hidden = true;
          return;
        }

        this.lang = document.documentElement.lang || undefined;
        this.rows = [];
        data.zones.forEach((zone) => {
          zone.countries.forEach((code) => {
            if (data.names[code]) this.rows.push({ code, name: data.names[code], zone });
          });
        });
        if (!this.rows.length) {
          this.hidden = true;
          return;
        }
        this.rows.sort((a, b) => a.name.localeCompare(b.name, this.lang));

        this.lineEl = this.querySelector('[data-ship-line]');
        this.dialog = this.querySelector('[data-ship-dialog]');
        this.list = this.querySelector('[data-ship-list]');

        this.current = this.pick();
        this.renderList();
        this.renderLine();

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-ship-open]')) this.open();
          else if (event.target.closest('[data-ship-close]') || event.target === this.dialog) this.dialog.close();
          else {
            const row = event.target.closest('[data-ship-code]');
            if (row) this.select(row.dataset.shipCode);
          }
        });
      }

      // Remembered choice first, then Shopify's detected country; null when we don't ship there.
      pick() {
        let saved = null;
        try {
          saved = localStorage.getItem('cw_ship_country');
        } catch (e) {}
        const known = (code) => this.rows.find((row) => row.code === code);
        return known(saved) || known(this.dataset.detected) || null;
      }

      select(code) {
        this.current = this.rows.find((row) => row.code === code) || this.current;
        try {
          localStorage.setItem('cw_ship_country', code);
        } catch (e) {}
        this.renderLine();
        this.renderList();
        this.dialog.close();
      }

      open() {
        if (typeof this.dialog.showModal !== 'function') return;
        this.dialog.showModal();
        const selected = this.list.querySelector('[aria-current="true"]');
        if (selected) selected.scrollIntoView({ block: 'center' });
      }

      days(zone) {
        const [min, max] = zone.days;
        return this.strings.days.replace('[min]', min).replace('[max]', max);
      }

      renderLine() {
        const button = (label) => {
          const el = document.createElement('button');
          el.type = 'button';
          el.className = 'ai-ship__country';
          el.dataset.shipOpen = '';
          el.append(label);
          return el;
        };
        this.lineEl.textContent = '';

        if (!this.current) {
          this.lineEl.append(button(this.strings.choose));
          return;
        }

        // Split on the placeholders so the country can be a real <button> and the sentence keeps
        // whatever word order the translation uses.
        const parts = this.strings.line.split(/(\[country\]|\[days\])/);
        parts.forEach((part) => {
          if (part === '[country]') this.lineEl.append(button(this.current.name));
          else if (part === '[days]') {
            // No-break span: "3–5 business days" must not split at the en dash.
            const days = document.createElement('span');
            days.className = 'ai-ship__nowrap';
            days.textContent = this.days(this.current.zone);
            this.lineEl.append(days);
          }
          else if (part) this.lineEl.append(part);
        });

        // Keep a "·" glued to the word before it so a wrapped line never starts with a stray dot:
        // when the country button is followed by a text node that opens with the dot, wrap the pair
        // in a no-break span.
        const country = this.lineEl.querySelector('.ai-ship__country');
        const after = country && country.nextSibling;
        if (after && after.nodeType === Node.TEXT_NODE && /^\s*·/.test(after.textContent)) {
          const glue = document.createElement('span');
          glue.className = 'ai-ship__nowrap';
          country.before(glue);
          const dot = after.textContent.match(/^\s*·\s*/)[0];
          after.textContent = after.textContent.slice(dot.length);
          glue.append(country, '\u00a0· ');
        }
      }

      renderList() {
        this.list.textContent = '';
        this.rows.forEach((row) => {
          const item = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ai-ship__row';
          button.dataset.shipCode = row.code;
          if (this.current && this.current.code === row.code) button.setAttribute('aria-current', 'true');

          const name = document.createElement('span');
          name.className = 'ai-ship__row-name';
          name.textContent = row.name;
          const meta = document.createElement('span');
          meta.className = 'ai-ship__row-meta';
          meta.textContent = this.days(row.zone);
          button.append(name, meta);
          item.append(button);
          this.list.append(item);
        });
      }
    }
  );
}
